import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const [loaded, setLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center px-8 pt-20">
      <div className="absolute inset-8 rounded-[40px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/181770413b1f912a1400d15b4ca7d304.jpg"
          alt="廃校活用プロジェクト"
          className={`w-full h-full object-cover object-top transition-transform duration-[2000ms] ease-out ${loaded ? 'scale-100' : 'scale-110'}`}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center max-w-5xl mx-auto w-full">
        <div
          className={`inline-flex items-center px-5 py-2.5 rounded-full border-2 border-white/40 backdrop-blur-sm mb-8 transition-all duration-700 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <i className="ri-leaf-line text-white text-base mr-2"></i>
          <span className="text-white text-sm font-medium whitespace-nowrap">地域創生 × 環境技術</span>
        </div>

        <h1
          className={`text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-7 leading-tight transition-all duration-700 delay-200 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          使われなくなった学校を<br />
          新しい産業と雇用を<br />
          生み出す拠点へ
        </h1>

        <p
          className={`text-lg md:text-xl text-white/95 mb-10 max-w-3xl mx-auto leading-relaxed transition-all duration-700 delay-[400ms] ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          廃校を活用した循環型陸上養殖プロジェクト。<br />
          筑波大学の先進技術と地域資源を活かし、持続可能な地域社会を実現します。
        </p>


      </div>

      <div
        className={`absolute bottom-16 left-1/2 -translate-x-1/2 transition-all duration-700 delay-[900ms] ${
          loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        <div className="w-6 h-10 rounded-full border-2 border-white/50 flex items-start justify-center p-1.5">
          <div className="w-1.5 h-1.5 rounded-full bg-white animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}